import { render, staticRenderFns } from "./credit-note-list.vue?vue&type=template&id=6676b9b3&scoped=true&"
import script from "./credit-note-list.vue?vue&type=script&lang=js&"
export * from "./credit-note-list.vue?vue&type=script&lang=js&"
import style0 from "./credit-note-list.vue?vue&type=style&index=0&id=6676b9b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676b9b3",
  null
  
)

export default component.exports